import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';

// Store
import store from "@/vue/planning/store/store";

// Enums
import {PaymentCondition} from "@/enums/paymentCondition"

// Components
import PaymentConditionPill from './PaymentConditionPill.vue';
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue";

// Props
interface Props {
    paymentCondition: number,
    displayTitle: boolean,
    isPVFlex?: boolean,
    prestId?: string
    isDisplayPlaceholders?:boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentCondition',
  props: {
    paymentCondition: null,
    displayTitle: { type: Boolean },
    isPVFlex: { type: Boolean },
    prestId: null,
    isDisplayPlaceholders: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    paymentCondition: number,
    displayTitle: boolean,
    isPVFlex?: boolean,
    prestId?: string
    isDisplayPlaceholders?:boolean
};





return { __sfc: true,props, store, PaymentCondition, PaymentConditionPill, PlaceholderBox }
}

})